import { useContext } from "react";
import { SearchParamsContext } from "../providers/SearchParamsProvider";
import { LinkType, LinkTypes } from "src/contexts/_shared/domain/LinkType";

export function useSearchParams() {
  const { slug, linkType, token } = useContext(SearchParamsContext);

  return {
    slug,
    linkType,
    token,
    isMagicLink: linkType && linkType.equals(new LinkType(LinkTypes.MAGIC_LINK)),
    isUserLink: linkType && linkType.equals(new LinkType(LinkTypes.USER_LINK)),
  };
}
